import { apiFetch } from './client';

export const assignmentReadsApi = {
  counts: () => apiFetch<{ issues: number; leads: number }>('/me/assignment-counts', { cache: 'no-store' }),
  mark: (kind: 'issues' | 'leads', id: number, assignmentVersion?: number) => {
    if (kind === 'issues' && (!Number.isSafeInteger(assignmentVersion) || assignmentVersion! < 0)) return Promise.reject(new Error('An observed assignment version is required.'));
    return apiFetch<{ read: true }>(`/me/record-reads/${kind === 'issues' ? 'issue' : 'lead'}/${id}`, {
      method: 'POST', ...(kind === 'issues' ? { body: JSON.stringify({ assignment_version: assignmentVersion }) } : {})
    });
  }
};
